// extracted by mini-css-extract-plugin
export var animationContainer = "_j5-0";
export var asteriskIcon = "_j5-8";
export var conversationLeftSection = "_j5-4";
export var conversationListItem = "_j5-3";
export var conversationMiddleSection = "_j5-5";
export var conversationRightSection = "_j5-6";
export var detailsContent = "_j5-1";
export var listContainer = "_j5-7";
export var modalContent = "_j5-2";